import "./Contact.css";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { ContactFormSection } from "./ContactFormSection";
import { ContactLocationSection } from "./ContactLocationSection";

export const Contact = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>VH BuildUp! - Contact</title>
        <meta name="description" content={t("helmet.meta.contact")} />
      </Helmet>
      <ContactFormSection />
      <ContactLocationSection />
    </>
  );
};
